/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ModulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse';
import { ModulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse } from '../model/modulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse';
import { ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse } from '../model/modulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse';
import { ModulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse } from '../model/modulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { LeaderboardsServiceInterface }                            from './leaderboards.serviceInterface';


@Injectable()
export class LeaderboardsService implements LeaderboardsServiceInterface {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Gets all round scores
     * Returns all round scores per player for the leaderboard.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse>;
    public getLeaderboardAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse>>;
    public getLeaderboardAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse>>;
    public getLeaderboardAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardAllLeaderboardAllResponse>('get',`${this.basePath}/leaderboards/all`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets base leaderboard
     * Returns base leaderboard with positions, projected cut, and points.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardBaseEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse>;
    public getLeaderboardBaseEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse>>;
    public getLeaderboardBaseEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse>>;
    public getLeaderboardBaseEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardBaseLeaderboardBaseResponse>('get',`${this.basePath}/leaderboards/base`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets leaderboard rows
     * Returns leaderboard for a tournament (optionally scoped to a round).
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardEndpoint(tournamentId?: string, roundId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse>>;
    public getLeaderboardEndpoint(tournamentId?: string, roundId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse>>>;
    public getLeaderboardEndpoint(tournamentId?: string, roundId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse>>>;
    public getLeaderboardEndpoint(tournamentId?: string, roundId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ModulesLeaderboardsApplicationGetLeaderboardLeaderboardRowResponse>>('get',`${this.basePath}/leaderboards`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets position by round
     * Returns position history across rounds for each player.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardPositionByRoundEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse>;
    public getLeaderboardPositionByRoundEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse>>;
    public getLeaderboardPositionByRoundEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse>>;
    public getLeaderboardPositionByRoundEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardPositionByRoundLeaderboardPositionByRoundResponse>('get',`${this.basePath}/leaderboards/position-by-round`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets cumulative scorecards
     * Returns cumulative scorecards across all rounds.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardScorecardsAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>;
    public getLeaderboardScorecardsAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>>;
    public getLeaderboardScorecardsAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>>;
    public getLeaderboardScorecardsAllEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>('get',`${this.basePath}/leaderboards/scorecards-all`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets scorecards
     * Returns hole-by-hole scorecards for the current round.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardScorecardsEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>;
    public getLeaderboardScorecardsEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>>;
    public getLeaderboardScorecardsEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>>;
    public getLeaderboardScorecardsEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardScorecardsLeaderboardScorecardsResponse>('get',`${this.basePath}/leaderboards/scorecards`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets scoring performance
     * Returns eagles, birdies, pars, bogeys breakdown per player.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardScoringPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse>;
    public getLeaderboardScoringPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse>>;
    public getLeaderboardScoringPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse>>;
    public getLeaderboardScoringPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardScoringPerformanceLeaderboardScoringPerformanceResponse>('get',`${this.basePath}/leaderboards/scoring-performance`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets stat performance
     * Returns fairways, GIR, putts, and driving stats per player.
     * @param tournamentId 
     * @param roundId 
     * @param playerTypeId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLeaderboardStatPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse>;
    public getLeaderboardStatPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse>>;
    public getLeaderboardStatPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse>>;
    public getLeaderboardStatPerformanceEndpoint(tournamentId?: string, roundId?: string, playerTypeId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (tournamentId !== undefined && tournamentId !== null) {
            queryParameters = queryParameters.set('TournamentId', <any>tournamentId);
        }
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('RoundId', <any>roundId);
        }
        if (playerTypeId !== undefined && playerTypeId !== null) {
            queryParameters = queryParameters.set('PlayerTypeId', <any>playerTypeId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetLeaderboardStatPerformanceLeaderboardStatPerformanceResponse>('get',`${this.basePath}/leaderboards/stat-performance`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets player course stats summary
     * Returns per-player course/stat totals and selected-round values with rankings.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerStatsCourseSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse>;
    public getPlayerStatsCourseSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse>>;
    public getPlayerStatsCourseSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse>>;
    public getPlayerStatsCourseSummaryEndpoint(tournamentId: string, roundId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getPlayerStatsCourseSummaryEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetPlayerStatsCourseSummaryPlayerStatsCourseSummaryResponse>('get',`${this.basePath}/playerstats/course/summary/${encodeURIComponent(String(tournamentId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Gets player scoring stats summary
     * Returns per-player scoring totals and selected-round values with rankings.
     * @param tournamentId 
     * @param roundId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPlayerStatsScoringSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'body', reportProgress?: boolean): Observable<ModulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse>;
    public getPlayerStatsScoringSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ModulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse>>;
    public getPlayerStatsScoringSummaryEndpoint(tournamentId: string, roundId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ModulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse>>;
    public getPlayerStatsScoringSummaryEndpoint(tournamentId: string, roundId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tournamentId === null || tournamentId === undefined) {
            throw new Error('Required parameter tournamentId was null or undefined when calling getPlayerStatsScoringSummaryEndpoint.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (roundId !== undefined && roundId !== null) {
            queryParameters = queryParameters.set('roundId', <any>roundId);
        }

        let headers = this.defaultHeaders;

        // authentication (Keycloak) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ModulesLeaderboardsApplicationGetPlayerStatsScoringSummaryPlayerStatsScoringSummaryResponse>('get',`${this.basePath}/playerstats/scoring/summary/${encodeURIComponent(String(tournamentId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
